import { render, staticRenderFns } from "./header_h5.vue?vue&type=template&id=f0ac95ea&scoped=true"
import script from "./header_h5.vue?vue&type=script&lang=js"
export * from "./header_h5.vue?vue&type=script&lang=js"
import style0 from "./header_h5.vue?vue&type=style&index=0&id=f0ac95ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ac95ea",
  null
  
)

export default component.exports